import { UseTargetTableColumns } from './type';

/* file description */
export const useTargetTableColumns: UseTargetTableColumns = ({ field }) => {
  const { tableColumn, searchColumn = [] } = field?.options || {};
  const targetTableColumns =
    tableColumn?.map((itemKey: string) => {
      const resColumn: Record<string, any> = {
        dataIndex: itemKey,
      };
      if (!searchColumn?.includes(itemKey)) {
        resColumn.search = false;
      } else {
        resColumn.searchOptions = {};
        resColumn.searchOptions.sequence = searchColumn.findIndex((item: string) => item === itemKey);
      }
      return resColumn;
    }) || [];
  return {
    targetTableColumns,
  };
};
